import React from 'react'
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Mapas from './../../Mapas/Mapas';
import Rodape from '../../Rodape/Rodape';

function Lojas_Localizacoes() {
  return (    
    <div>      
      <NavBarTop />
      <Mapas />
      <Rodape />
    </div>
  )
}

export default Lojas_Localizacoes